import { post } from '@/util/http'

/**
 * 机构统计
 *
 * @return Result
 */
export const aggregationPlanActivity = params => post(`/plan/aggregation/planActivity`, params);
